module.exports = __webpack_public_path__ + "img/07.f105368f.png";